import React, { useEffect, useState } from 'react';

import { Alert, Button } from 'antd';

import { usePhysicalDeliveryStore } from 'v2/store/PhysicalDelivery';

import Input from './components/Input';
import { deepClone, redirectToMelhorEnvioAuth } from './helpers';
import { alertMessages, fieldHelpMessages } from './messages';
import type { AlertState } from './types';
import { schema, validate, isValid } from './validations';
import { isIntegrationMelhorEnvio, isIntegrationActive } from '../../../../helpers';
import type { ActiveIntegrationResponse } from '../../../../types';

interface IProps {
  integration: ActiveIntegrationResponse;
  onEdit?: () => void;
}

const MelhorEnvio = ({ integration, onEdit }: IProps) => {
  const { delivery: physicalDelivery, setDelivery } = usePhysicalDeliveryStore();
  const [alert, setAlert] = useState<AlertState>({
    visible: false
  });
  const [validations, setValidations] = useState({});

  const handleAlertExhibition = () => {
    if (!isIntegrationMelhorEnvio(integration)) {
      setAlert({
        visible: true,
        ...alertMessages.vinculate
      });
      return;
    }

    if (!isIntegrationActive(integration)) {
      setAlert({
        visible: true,
        ...alertMessages.reactivate
      });
      return;
    }

    setAlert({ visible: false });
  };

  const handleChangeDeliveryFields = async (key: string, value: any) => {
    const _physicalDelivery = deepClone(physicalDelivery);
    _physicalDelivery[key] = value;
    setDelivery(_physicalDelivery);

    const _validations = validate(_physicalDelivery, schema);
    setValidations(_validations);

    if (onEdit) {
      onEdit();
    }
  };

  const handleCloseAlert: () => void = () => setAlert({ ...alert, visible: false });

  useEffect(() => {
    handleAlertExhibition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [integration]);

  return (
    <div className='flex w-full flex-col gap-1'>
      {alert.visible && (
        <div className='px-2'>
          <Alert
            type='warning'
            closable
            onClose={handleCloseAlert}
            message={alert.title}
            description={alert.description}
            action={
              <Button type='primary' onClick={() => redirectToMelhorEnvioAuth(handleCloseAlert)}>
                {alert.buttonText}
              </Button>
            }
          />
        </div>
      )}
      <div className='flex flex-col gap-[10px] px-2'>
        <Input
          label='Peso do produto'
          id='weight'
          mask='money'
          helperText={fieldHelpMessages['weight']}
          error={isValid(validations, 'weight')}
          value={physicalDelivery.weight}
          onChange={value => handleChangeDeliveryFields('weight', value)}
          endAdornment='kg'
        />
        <Input
          label='Altura do produto'
          id='height'
          mask='number'
          helperText={fieldHelpMessages['height']}
          error={isValid(validations, 'height')}
          value={physicalDelivery.height}
          onChange={value => handleChangeDeliveryFields('height', value)}
        />
        <Input
          label='Largura do produto'
          id='width'
          mask='number'
          helperText={fieldHelpMessages['width']}
          error={isValid(validations, 'width')}
          value={physicalDelivery.width}
          onChange={value => handleChangeDeliveryFields('width', value)}
        />
        <Input
          label='Comprimento do produto'
          id='length'
          mask='number'
          helperText={fieldHelpMessages['length']}
          error={isValid(validations, 'length')}
          value={physicalDelivery.length}
          onChange={value => handleChangeDeliveryFields('length', value)}
        />
      </div>
    </div>
  );
};

export default MelhorEnvio;
